/**
 * Created by mykurisu on 2017/11/20.
 */
import React from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import '../../css/wkCommon.css'
import ShareCardGiftIcon from '../../images/share-gift-icon.png'
import ShareCardMoneyIcon from '../../images/sharecard-money.png'


class WKSharecardEntry extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shouldShow: false,
        };
        this.el = props.el || window
    }

    componentDidMount() {
        this.el.addEventListener('scroll', () => this.handleScroll());
        setTimeout(() => {
            this.handleCssShow(this.entry, 0.5)
        }, 1000)
    }

    componentWillUnmount() {
        this.el.removeEventListener('scroll', () => this.handleScroll());
        this.cardSlide && clearTimeout(this.cardSlide);
        this.intervalShow && clearTimeout(this.intervalShow);
        this.cssShow && clearTimeout(this.cssShow);
    }

    handleScroll() {
        this.cardSlide && clearTimeout(this.cardSlide);

        let self = this;

        this.intervalShow = () => {
            self.handleCssShow(this.entry, 0.5)
        };

        if (this.entry){
            if (this.handleGetScrollTop() > (this.props.minScroll || 168)){
                this.cardSlide = setTimeout(this.intervalShow, 3000);

                if (this.entry.style.width !== '28px'){
                    this.entry.style.width = '28px';
                }
            }else {
                this.cardSlide = setTimeout(this.intervalShow, 3000);
            }
        }
    }

    handleGetScrollTop() {
        if (this.el === window) {
            return document.body.scrollTop || document.documentElement.scrollTop
        } else {
            return this.el.scrollTop
        }
    }

    handleCssShow(ele, time) {
        if (typeof window.getComputedStyle === 'undefined') return;

        let width = ele.style.width;
        ele.style.transition = 'none';
        ele.style.width = 'auto';
        let targetWidth = window.getComputedStyle(ele).width;
        ele.style.width = width;

        if (time) ele.style.transition = `width ${time}s`;

        this.cssShow = setTimeout(() => {
            ele.style.width = targetWidth;
        }, 300);
    }

    render() {
        const {sharecard} = this.props;
        return (
        <Link to={{pathname: `/${sharecard.type}/${sharecard.id}/sharecard`}}>
            <div className="wk-sharecard-entry">
                <div className="entry__container" style={{width: '28px'}} ref={r => this.entry = r}>
                    <div className="container__text">
                        {sharecard.title ? sharecard.title : '邀请好友'}
                    </div>
                    <div className="container__icon">
                        <div className={sharecard.is_resell ? "icon__img-money" : "icon__img-gift"}>
                            <img className={sharecard.is_resell ? "share-card-entry_icon-money-animation" : ''}
                                 src={sharecard.is_resell ? ShareCardMoneyIcon : ShareCardGiftIcon} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
        )
    }
}

export default connect(state => ({
    sharecard: state.sharecard,
}))(WKSharecardEntry)



// WEBPACK FOOTER //
// ./src/components/wk/WKSharecardEntry.js